module.exports = __webpack_public_path__ + "static/media/mylocationicon.d7717a2f.svg";